import { addCardChrome } from '../chrome';
import { getActiveDiagram } from '../theme';
import { centerTextX } from './measure';
var defaultBoxStyle = function () { return ({
    strokeWidth: getActiveDiagram().stroke.node,
    shadow: getActiveDiagram().shadowSoft,
}); };
/** Labeled rounded rectangle — shared node chrome for all diagram types. */
export function createLabeledBox(app, label, width, height, style, textOpts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (style === void 0) { style = {}; }
    if (textOpts === void 0) { textOpts = {}; }
    var _l = defaultBoxStyle(), strokeWidth = _l.strokeWidth, shadow = _l.shadow;
    var node = app.group();
    node.metadata.diagramCardWidth = width;
    node.metadata.diagramCardHeight = height;
    var fontSize = (_a = textOpts.fontSize) !== null && _a !== void 0 ? _a : getActiveDiagram().fontSize.base;
    var radius = (_b = style.cornerRadius) !== null && _b !== void 0 ? _b : getActiveDiagram().radii.md;
    addCardChrome(app, node, {
        width: width,
        height: height,
        cornerRadius: radius,
        fill: (_c = style.fill) !== null && _c !== void 0 ? _c : getActiveDiagram().nodeFill,
        stroke: (_d = style.stroke) !== null && _d !== void 0 ? _d : getActiveDiagram().nodeStroke,
        strokeWidth: (_e = style.strokeWidth) !== null && _e !== void 0 ? _e : strokeWidth,
        shadow: style.shadow !== null ? ((_f = style.shadow) !== null && _f !== void 0 ? _f : shadow) : null,
        accentColor: style.accentColor,
        sheen: style.sheen,
    });
    node.add(app.text({
        text: label,
        x: centerTextX(label, width, fontSize, (_g = textOpts.fontWeight) !== null && _g !== void 0 ? _g : '600'),
        y: (_h = textOpts.y) !== null && _h !== void 0 ? _h : height / 2 - fontSize / 2 - 1,
        fontSize: fontSize,
        fontWeight: (_j = textOpts.fontWeight) !== null && _j !== void 0 ? _j : '600',
        fontFamily: getActiveDiagram().fontFamily,
        fill: (_k = textOpts.fill) !== null && _k !== void 0 ? _k : getActiveDiagram().nodeText,
        listening: false,
    }));
    return node;
}
